export default "__VITE_ASSET__CwY4cLR$__"